var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_11",
    "data-name": "Calque 11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M670.67,679.38l-49.6-49.6a165.78,165.78,0,1,0-242.15,0l-49.6,49.6A9.69,9.69,0,1,0,343,693.09l49.94-50a165.75,165.75,0,0,0,214.06,0l49.93,50a9.69,9.69,0,1,0,13.71-13.71ZM511.08,541.93H404.26V522.55h87.43V401h19.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.33,318.51c-9.59-5.58-23.84-12.07-40.43-14-34.41-4-65.92,19.24-74,52.93a116.55,116.55,0,0,0,.22,54.53,11.26,11.26,0,0,0,18.16,6l97.59-81.13A11.25,11.25,0,0,0,433.33,318.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566.67,318.51c9.59-5.58,23.84-12.07,40.43-14,34.41-4,65.92,19.24,74,52.93a116.55,116.55,0,0,1-.22,54.53,11.26,11.26,0,0,1-18.16,6l-97.59-81.13A11.25,11.25,0,0,1,566.67,318.51Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemind);
export default __webpack_public_path__ + "static/media/remind.347c0672b97911e6ef0200d03f19ea1b.svg";
export { ForwardRef as ReactComponent };